import { GetUserProjectsOptions, UserProjectService } from '@services/userProjectService';
import { useQuery } from '@tanstack/react-query';

export const useUserProjects = (options: GetUserProjectsOptions) => {
  return useQuery({
    initialData: {
      data: [],
      total: 0,
      page: 1,
      pageSize: 10,
    },
    queryKey: [
      'userProjects',
      options.status,
      options.courseId,
      options.page,
      options.pageSize,
      options.projectId,
    ],
    queryFn: () => UserProjectService.getAll(options),
  });
};
